import Link from 'next/link'
import styles from 'web/pages/gallery.module.css'
import { convert as romanNumeral } from 'roman-numeral'
import TamaGawdtchiHealth from 'web/components/TamaGawdtchiHealth'
import Gawd from 'web/lib/gawd'
import PowerIcon from './PowerIcon'
import useEnvironment from 'web/hooks/useEnvironment'
import useLoadGawdMetadata from 'web/hooks/useLoadGawdMetadata'
import { useMemo, useRef } from 'react'
import useOnScreen from 'web/hooks/useOnScreen'
import Bubble from './Bubble'
import usePortalShutdown from 'web/hooks/usePortalShutdown'

export type ItemProps = {
  gawd: Gawd
  isWallet?: boolean
}

export default function GalleryGawdItem({ gawd, isWallet = false }: ItemProps) {
  const ref = useRef()
  const isOnScreen = useOnScreen(ref)
  gawd = useLoadGawdMetadata(gawd, !isOnScreen)

  const minGawdId = useMemo(() => 5548, [])

  return (
    <li className="relative" key={gawd.id()} ref={ref}>
      <Link href={gawd.id() > 0 ? `/gallery/${gawd.id()}` : ''} passHref={true}>
        <a className="block space-y-8 m-1 p-10 pb-8 md:p-16 md:pb-8 rounded-lg no-underline text-white hover:no-underline bg-gray-800 hover:bg-gray-900 focus:ring-2 focus:ring-red-500 sm:p-8 lg:p-16 transition-all">
          <div className="block w-full aspect-w-10 aspect-h-10 rounded-lg">
            <img src={gawd.previewImage()} alt="" className={styles.circle} />
            <div className="absolute inset-0">
              <span className="sr-only">View details for {gawd.id()}</span>
            </div>
          </div>

          <div className="space-y-4">

            <p className="block text-center text-sm font-medium truncate pointer-events-none">
              <PowerIcon power={gawd.dominantPower} className="w-3 h-3 inline fill-white mr-1" />
              {gawd.loaded ? gawd.name() : '...'}
            </p>

            {/* only show energy bar when value present - aka show this on wallet page, but not gallery page */}
            {/* and only if gawchi enabled globally */}
            {isWallet && gawd.loaded &&
              <TamaGawdtchiHealth gawdId={gawd.id()} />}

            <p className="block text-sm font-medium text-center text-red-500">
              {(gawd.id() && romanNumeral(gawd.id())) || '???'}
            </p>


          </div>
        </a>
      </Link>
    </li>
  )
}
